import React from 'react'

const PageNotFound = () => {
  return (
    <main className='flex-1 flex flex-col items-center justify-center'>
      <div>Oops! This page does not exist</div>
      <button className='mt-4 bg-emerald-500 active:bg-emerald-600 p-1 px-4 text-sm font-bold rounded'><a href='/'>Go back</a></button>
    </main>
  )
}

export default PageNotFound